import React, { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AccountsContext } from "../../context/AccountsContext";
import useToggle from "../../hooks/useToggle";
import { ModalConfirmPhone } from "../../views/Admin/PersonalInfo/ModalConfirmPhone";
import SmallButton from "../SmallButton";
import Step from "./Step";
import { Container } from "./styles";

interface StepsProps {
  currentStep: number;
  onRequestLink: () => void;
  onAlterPhone: () => void;
  onCloseModal: () => void;
  phone: string;
  loadingModal: number;
  statusModal: string;
}

const ValidateProgress: React.FC<StepsProps> = ({
  currentStep,
  onRequestLink,
  onAlterPhone,
  onCloseModal,
  phone,
  loadingModal,
  statusModal,
}) => {
  const [isConfirmPhoneModalOpen, setIsConfirmPhoneModalOpen] =
    useToggle(false);

  const { user } = useContext(AccountsContext);

  useEffect(() => {
    if (statusModal !== "confirm") {
    }
  }, [statusModal]);

  const handleStepClick = () => {
    if (user?.cellphone_verified == 0) {
      toast.error("Por favor, preencha e verifique seu celular.");
    } else {
      setIsConfirmPhoneModalOpen();
    }
  };

  const handleAlterphone = () => {
    setIsConfirmPhoneModalOpen();
    onAlterPhone();
  };

  const handleCloseModal = () => {
    onCloseModal();
    setIsConfirmPhoneModalOpen();
  };

  return (
    <Container>
      <Step stepNumber={1} currentStep={currentStep}>
        {currentStep <= 1 ? (
          <>
            Solicite o link
            {currentStep && (
              <SmallButton
                secondaryOutline
                style={{ marginTop: "6px" }}
                onClick={handleStepClick}
              >
                Clique aqui
              </SmallButton>
            )}
          </>
        ) : (
          <>Solicitou o link de acesso</>
        )}
      </Step>

      <Step stepNumber={2} currentStep={currentStep}>
        {currentStep <= 2 ? (
          <>Acesse o link enviado via SMS no seu celular</>
        ) : (
          <>Acessou o link via SMS no seu celular</>
        )}
      </Step>

      <Step stepNumber={3} currentStep={currentStep}>
        {currentStep <= 4 ? (
          <>Siga as etapas para cadastrar a biometria</>
        ) : (
          <>Seguiu as etapas e cadastrou a biometria</>
        )}
      </Step>

      <Step stepNumber={4} currentStep={currentStep}>
        Pronto! Sua conta está protegida
      </Step>

      <ModalConfirmPhone
        loading={loadingModal}
        status={statusModal}
        phoneString={phone}
        isOpen={isConfirmPhoneModalOpen}
        closeModal={handleCloseModal}
        onAlterPhone={handleAlterphone}
        onConfirmPhone={onRequestLink}
      />
    </Container>
  );
};

export default ValidateProgress;
